export const findById = <T extends { id: string }>(list: T[], id: string) =>
  list.find((it) => it.id === id);
